var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833313 17.5H19.1666L9.99998 1.66667L0.833313 17.5ZM10.8333 15H9.16665V13.3333H10.8333V15ZM10.8333 11.6667H9.16665V8.33334H10.8333V11.6667Z",
    fill: "#006F33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningGreen);
export default __webpack_public_path__ + "static/media/Warning_Green.8ed801ebf23473054944ac4501d0ae8d.svg";
export { ForwardRef as ReactComponent };